
const stateObj = {
  isReportMode: false,
}

const getters = {
  getIsReportMode (state) {
    return state.isReportMode
  },
}

const mutations = {
  setIsReportMode (state, isReportMode) {
    state.isReportMode = isReportMode
  },
}

const actions = {
}

export default {
  actions,
  getters,
  mutations,
  state: stateObj,
}
